export default __webpack_public_path__ + "static/media/old-district-office-main.3ad49957.jpg";